export default defineNuxtRouteMiddleware(async to => {
    const currentUser = await getCurrentUser()
    if (!currentUser) {
        return navigateTo({
            name: "resources-signup",
            query: {
                redirectedFrom: to.fullPath
            }
        })
    } else if (!currentUser.emailVerified && to.name != "resources-login") {
        return navigateTo({
            name: "resources-login",
            query: {
                redirectedFrom: to.fullPath,
                unverified: "true"
            }
        })
    } 
})
  